import { SubmitHandler } from 'react-hook-form';

import { IFlagsmith } from 'flagsmith/types';
import { EventsTrackerRepository } from 'hooks/events-tracker/useEventsTracker';
import { AuthRepository } from '../../domain';
import { AuthStore, DetailError } from '../../domain/AuthStore';
import { UnifiedRegisterData } from '../../domain/entity/UnifiedRegisterData';
import { unifiedRegisterUseCase } from '../../useCases/UnifiedRegisterUseCase';

interface UseUnifiedRegisterProps {
  authStore: AuthStore;
  authRepository: AuthRepository;
  eventsTracker: EventsTrackerRepository;
  featureFlagsManager: IFlagsmith;
  setDetailError: (arg: DetailError[]) => void;
}

function useUnifiedRegister({
  authStore,
  eventsTracker,
  authRepository,
  featureFlagsManager,
  setDetailError,
}: UseUnifiedRegisterProps) {
  const onSubmit: SubmitHandler<UnifiedRegisterData> = async (
    props: UnifiedRegisterData
  ) => {
    const unifiedRegisterData: UnifiedRegisterData = props;
    await unifiedRegisterUseCase({
      authStore,
      eventsTracker,
      authRepository,
      unifiedRegisterData,
      featureFlagsManager,
    });
  };

  if (authStore.detailErrors) {
    setDetailError(authStore.detailErrors);
  }

  return {
    onSubmit,
    isLoading: authStore.isLoading,
    isAuthError: !!authStore.authError,
  };
}

export default useUnifiedRegister;
